import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AtelierRecupEventService {
  private recupDetailCloseSubject = new Subject<never>();

  public getRecupDetailCloseSubject(): Subject<never> {
    return this.recupDetailCloseSubject;
  }
}
